export default __webpack_public_path__ + "static/media/car_filled.7bd84246.svg";